import React, { useState, useEffect } from 'react';
import styles from './Dashboard.module.css';
import apiClient from '../../../api/client';
import { getCairoToday } from '../../../utils/cairoDate';

const Dashboard = () => {
  const [stats, setStats] = useState([
    { id: 1, title: 'إجمالي الطلاب', value: '...', icon: '👨‍🎓' },
    { id: 2, title: 'الامتحانات', value: '...', icon: '📝' },
    { id: 3, title: 'حضور اليوم', value: '...', icon: '✅' },
    { id: 4, title: 'غياب اليوم', value: '...', icon: '❌' },
  ]);

  useEffect(() => {
    const loadStats = async () => {
      try {
        const today = getCairoToday();
        const [studentsRes, examsRes, attendanceRes] = await Promise.all([
          apiClient.get('/students'),
          apiClient.get('/exams'),
          apiClient.get(`/attendance?date=${today}`),
        ]);

        const presentCount = attendanceRes.data.filter((a) => a.status === 'present').length;
        const absentCount = attendanceRes.data.filter((a) => a.status === 'absent').length;

        setStats([
          { id: 1, title: 'إجمالي الطلاب', value: studentsRes.data.length, icon: '👨‍🎓' },
          { id: 2, title: 'الامتحانات', value: examsRes.data.length, icon: '📝' },
          { id: 3, title: 'حضور اليوم', value: presentCount, icon: '✅' },
          { id: 4, title: 'غياب اليوم', value: absentCount, icon: '❌' },
        ]);
      } catch (error) {
        console.error('❌ مشكلة في جلب إحصائيات لوحة التحكم:', error);
      }
    };
    loadStats();
  }, []);

  return (
    <div className={styles.dashboardWrapper}>

      <section>
        <h2 className={styles.sectionTitle}>نظرة عامة</h2>
        <div className={styles.statsGrid}>
          {stats.map((stat) => (
            <div key={stat.id} className={styles.statCard}>
              <div className={styles.statInfo}>
                <h3>{stat.title}</h3>
                <p>{stat.value}</p>
              </div>
              <div className={styles.iconBox}>
                {stat.icon}
              </div>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
};

export default Dashboard;
